import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import users from './users'
import acciones from './accionesIndependientes'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    users,
    acciones
  }
})
